import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';

/**
 * React 18 compatible Moment component
 * This is a wrapper around moment.js to replace react-moment
 * which has compatibility issues with React 18
 */
const Moment = ({ 
  children, 
  format = 'YYYY-MM-DD', 
  date,
  fromNow,
  fromNowDuring,
  from,
  to,
  toNow,
  calendar,
  unix,
  utc,
  tz,
  locale,
  element = 'time',
  ...props 
}) => {
  // Get the date value
  let dateValue = date || children;
  
  // Create moment object
  let m;
  
  if (unix) {
    m = moment.unix(dateValue);
  } else if (utc) {
    m = moment.utc(dateValue);
  } else {
    m = moment(dateValue);
  }
  
  // Apply timezone if specified
  if (tz) {
    m = m.tz(tz);
  }
  
  // Apply locale if specified
  if (locale) {
    m = m.locale(locale);
  }
  
  // Format the output
  let output;
  
  if (fromNow) {
    output = m.fromNow();
  } else if (fromNowDuring) {
    output = m.fromNow(true);
  } else if (from) {
    output = m.from(from);
  } else if (to) {
    output = m.to(to);
  } else if (toNow) {
    output = m.toNow();
  } else if (calendar) {
    output = m.calendar();
  } else {
    output = m.format(format);
  }
  
  // Return as specified element
  const Element = element;
  return <Element {...props}>{output}</Element>;
};

Moment.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.instanceOf(Date)
  ]),
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.instanceOf(Date)
  ]),
  format: PropTypes.string,
  fromNow: PropTypes.bool,
  fromNowDuring: PropTypes.bool,
  from: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.instanceOf(Date)
  ]),
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.instanceOf(Date)
  ]),
  toNow: PropTypes.bool,
  calendar: PropTypes.bool,
  unix: PropTypes.bool,
  utc: PropTypes.bool,
  tz: PropTypes.string,
  locale: PropTypes.string,
  element: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ])
};

export default Moment;
